import React, { useState } from "react";
import { useRouter } from "../../../lib/hooks/useRouter";
import { useContacts } from "../../../api/grpc/contacts/useContacts";
import { toast } from "react-toastify";
import { useMsal } from "@azure/msal-react";

import { CompleteSignupFormik } from "../../../components/CompleteSignup/lib/useCompleteSignupFormik";
import { PrivacyTerms } from "../PrivacyTerms/PrivacyTerms";
import { ProviderButton } from "../../../components/Insights/shared/ProviderButtons/ProviderButton";
import { microsoftSignupRequest } from "../../../components/Login/authConfig";

interface Props {
  formik: CompleteSignupFormik;
}

export const CompleteWithO365 = ({ formik }: Props) => {
  const { instance } = useMsal();
  const { contactMicrosoftSocialRegistration } = useContacts();
  const { query } = useRouter();
  const { history } = useRouter();
  const [customError, setCustomError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleO365SignUp = async () => {
    if (!formik.values.privacyTerms) {
      return setCustomError(true);
    } else {
      setCustomError(false);
    }

    try {
      if (!query.customerID) {
        toast.error("TenantID not found to complete the sign up!");
        return;
      }

      const email = (
        formik.values.workEmail ||
        query.email ||
        ""
      )
        .toString()
        .replace(/ /g, "+")
        .toLowerCase();

      if (!email) {
        toast.error("Email not found to complete the sign up!");
        return;
      }

      setLoading(true);

      const loginResponse = await instance.loginPopup(microsoftSignupRequest);

      if (!loginResponse.account) {
        throw new Error("Microsoft account not found!");
      }

      instance.setActiveAccount(loginResponse.account);

      const tokenResponse = loginResponse.accessToken
        ? loginResponse
        : await instance.acquireTokenSilent({
            account: loginResponse.account,
            scopes: microsoftSignupRequest.scopes,
          });

      await contactMicrosoftSocialRegistration(
        tokenResponse.accessToken,
        email,
        query.customerID
      );

      history.push("/account-confirmed");
      return;
    } catch (error: any) {
      const code = (error?.errorCode || error?.code || "")
        .toString()
        .toLowerCase();
      const message = (error?.message || "").toString().toLowerCase();
      const isUserCancelled =
        code === "user_cancelled" ||
        code === "popup_closed" ||
        code === "auth_cancelled" ||
        message.includes("user cancelled") ||
        message.includes("user canceled");

      if (!isUserCancelled) {
        toast.error(error?.message ?? "Microsoft sign up failed!");
      }
      console.error("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ProviderButton
        type="Office 365"
        handleClick={handleO365SignUp}
        disabled={loading}
      />

      <PrivacyTerms
        formik={formik}
        className="mt-3"
        customError={customError}
      />
    </>
  );
};
